import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { eiwrsRandomizationSchemaServices } from "../../../../../APIServices/EIWRS/eiwrsRandomizationSchemaServices";

const ReassignRandomizationSubject = ({ siteId, subjectId, schemaId, getStudySiteSubjectList, Show, Hide, Title, subjectSettings }) => {
  const [randomizerId, setRandomizerId] = useState("");
  const [randomizationType, setRandomizationType] = useState("");
  const [checkRandomizerId, setCheckRandomizerId] = useState("");
  const [randomizerSchemaList, setRandomizerSchemaList] = useState([]);
  const [randomizationEventList, setRandomizationEventList] = useState([]);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [eventLoader, setEventLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [selectedChecks, setSelectedChecks] = useState([]);

  const handleChange = (eventId, timepointUniqueId, schemaId) => {
    setSelectedChecks((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.eventId === eventId &&
          String(item.timepointUniqueId || "") === String(timepointUniqueId || "")
      );

      const newItem = {
        eventId,
        timepointUniqueId,
        schemaId,
      };

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = newItem;
        return updated;
      }

      return [...prev, newItem];
    });
  };

  const updateStudySubjectRowData = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Re-Assign Randomization Schema!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, re-assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        if (subjectSettings === "IWRS") {
          userData.randomizerId = randomizerId;
          if (randomizationType === "assignBased") {
            userData.assignBasedSchema = selectedChecks;
          }
        }
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          setButtonLoader(false)
          Hide()
        }
      }
    });
  };

  const getEIWRSSiteRandomizationSchemaData = async (e) => {
    let data = await eiwrsRandomizationSchemaServices.getEIWRSSiteRandomizationSchemaData(
      studyId,
      siteId
    );
    setRandomizerSchemaList(data?.data || []);
  };

  const getStudySingleSubjectRow = async () => {
    setLoader(true)
    let data = await studySubjectManagementServices.getStudySingleSubjectRow(studyId, siteId, subjectId)
    setRandomizerId(data?.data?.randomizerId || "")
    setCheckRandomizerId(data?.data?.randomizerId || "")
    setSelectedChecks(data?.data?.assignBasedSchema || [])
    setLoader(false)
  }

  const getRandomizationEventBasedonSchema = async () => {
    setEventLoader(true)
    let data = await eiwrsRandomizationSchemaServices.getRandomizationEventBasedonSchema(studyId, schemaId)
    setRandomizationEventList(data?.data || [])
    setEventLoader(false)
  }

  const initializeData = async () => {
    if (!siteId || !subjectId) return;
    await getStudySingleSubjectRow();
    await getEIWRSSiteRandomizationSchemaData();
  };

  useEffect(() => {
    initializeData();
  }, [siteId, subjectId]);

  useEffect(() => {
    if (!randomizerId || !schemaId) return;
    const checkRandomizer = randomizerSchemaList?.find(
      (item) => item.schemaId === randomizerId
    );
    setRandomizationType(checkRandomizer?.randomizationType || "")
    if (checkRandomizer?.randomizationType === "assignBased") {
      getRandomizationEventBasedonSchema();
    }
  }, [schemaId, randomizerId, randomizerSchemaList]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {loader ? (
            <PageLoader />
          ) : (
            <>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Randomization Schema{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  style={{ fontSize: 12 }}
                  className="br3"
                  value={randomizerId}
                  disabled={randomizerSchemaList?.length <= 1}
                  onChange={(e) => {
                    setRandomizerId(e.target.value);
                    setRandomizationType(e.target[e.target.selectedIndex].title);
                  }}
                >
                  <option value="">{randomizerSchemaList?.length === 0 ? "No Randomization Schema" : "Select Randomization Schema"}</option>
                  {randomizerSchemaList?.map((item, index) => (
                    <option key={index} value={item?.schemaId} title={item?.randomizationType}>{item?.schemaName}</option>
                  ))}
                </Form.Select>
              </Form.Group>
              {randomizationType === "assignBased" &&
                <>
                  <Form.Label className="fw-bold mb-1">
                    Select Assign Based Schema{" "}
                    <abbr title="Required" className="text-danger">
                      *
                    </abbr>
                  </Form.Label>
                  {(randomizationEventList || [])?.map((item, index) => (
                    <Form.Group key={index} className="mb-1" style={{ marginLeft: 12 }}>
                      <Form.Label className="fw-bold mb-1">
                        {item?.row?.EVENTID}
                        {item?.row?.TIMEPOINUNIQUEID
                          ? ` (${item?.row?.TIMEPOINID})`
                          : ""}
                        <abbr title="Required" className="text-danger">*</abbr>
                      </Form.Label>

                      {(item?.checkList || []).map((check, key) => (
                        <div key={key} className="hstack gap-2">
                          <Form.Check
                            type="radio"
                            style={{ fontSize: 12, marginLeft: 12 }}
                            name={`${item.eventId}_${item.row?.TIMEPOINTUNIQUEID || ""}`}
                            checked={
                              (selectedChecks || [])?.some(
                                (x) =>
                                  x.eventId === item.eventId &&
                                  String(x.timepointUniqueId || "") ===
                                  String(item.row?.TIMEPOINTUNIQUEID || "") &&
                                  x.schemaId === check.checkId
                              )
                            }
                            onChange={() =>
                              handleChange(
                                item.eventId,
                                item.row?.TIMEPOINTUNIQUEID || "",
                                check.checkId
                              )
                            }
                          />
                          <Form.Label className="mb-0">{check.label}</Form.Label>
                        </div>
                      ))}
                    </Form.Group>
                  ))}
                </>
              }
            </>
          )}
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={
              randomizationType === "assignBased" ?
                (buttonLoader || !randomizerId || (selectedChecks || [])?.length !== (randomizationEventList || [])?.length)
                :
                (buttonLoader || !randomizerId)
            }
            onClick={updateStudySubjectRowData}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> {checkRandomizerId ? "Re-assigning" : "Assigning"}...
              </div>
            ) : (
              checkRandomizerId ? "Re-assign Randomization Number" : "Assign Randomization Number"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ReassignRandomizationSubject;
